import React from 'react';

import { SitecoreAnalyticsContext } from './analytics-context.types';

declare global {
  interface Window {
    hcaAnalyticsContext: Record<string, string>;
  }
}

export const OASAnalyticsContext: React.FC<SitecoreAnalyticsContext> = ({ fields }) => {
  React.useEffect(() => {
    if (window) {
      window.hcaAnalyticsContext = {
        ...fields,
      };
    }
  }, [fields]);

  return null;
};
